import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'
import theme from 'ui/styles/theme'
import LocalizedString from 'ui/components/generic/LocalizedString'

const Wrapper = styled.div`
  margin-bottom: 90px;
`

const OffsetCol = styled(Col)`
  min-width: 80vw;

  ${media.sm`
    min-width: 321px;
  `}

  ${media.lg`
    min-width: initial;
  
    &:nth-child(odd) {
      margin-top: 2vw;
    }
  `}
`

const ScrollContainer = styled(Row)`
  flex-wrap: nowrap;
  overflow-x: scroll;
`

const Content = styled.div`
`

const Title = styled.h2`
  border-top: 1px solid ${theme.colors.tones.darker};
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  margin-bottom: 60px;
  margin-top: 30px;
  padding-top: 30px;
  text-transform: uppercase;
`

const Image = styled.div`
  background: url(${props => props.background}) center / cover;
  height: 0;
  padding-bottom: 75%;
  width: 100%;
`

const Text = styled.p`
  color: ${theme.colors.tones.dark};
  font-size: 20px;
  line-height: 24px;
  margin-top: 23px;
`

const CTA = styled.p`
  color: ${theme.colors.primary};
  font-size: 12px;
  font-weight: 500;
  margin-top: 35px;
  text-transform: uppercase;
`

export default class FeaturedLinks extends Component {
  render() {
    const { title, links } = this.props

    return (
      <Wrapper>
        <Container fluid>
          <Row>
            <Col>
              <Title>{title}</Title>
            </Col>
          </Row>
          <ScrollContainer>
            {links.map((link) => {
              return (
                <OffsetCol sm={3}>
                  <Link to={getRelativeUrl(link.link)}>
                    <Content>
                      <Image background={link.image.sourceUrl} />
                      <Text>{link.text}</Text>
                      <CTA>
                        <LocalizedString
                          group="genericLabels"
                          string="readMore"
                        />
                      </CTA>
                    </Content>
                  </Link>
                </OffsetCol>
              )
            })}
          </ScrollContainer>
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/FeaturedLinks/index.js